import { useEffect } from "react";

function InvoicePageFilter(props) {
  useEffect(() => {}, [props?.bulkActionData]);

  const createSelectItems = () => {
    let items = [];
    props?.bulkActionData?.forEach((item, i) => {
      items.push(
        <option key={i} value={item?.Filtering_Sorting}>
          {item.Filtering_Name}
        </option>
      );
    });

    return items;
  };

  const handleChange = (value) => {
    props.onFilterAction(value);
  };

  return (
    <>
      <select
        className="w-[250px] h-[40px] text-sm border border-gray-200 rounded-md outline-none focus:outline-none ring-1 ring-gray-200"
        onChange={handleChange}
      >
        {createSelectItems()}
      </select>
    </>
  );
}

export default InvoicePageFilter;
